'use client';
import { isFunction } from '@s7/utils';

/**
 * Существует ли ReadableStream в контексте исполнения.
 * (Поддерживается ли Streaming API (для запросов) в контексте исполнения.)
 * */ const supportsResponseStreams = isFunction(globalThis.ReadableStream);

export { supportsResponseStreams };
//# sourceMappingURL=supportsResponseStreams.js.map
